import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { Tooltip, ButtonGroup as ButtonGroup$1, Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ButtonGroup = ({ options, selectedIndex, setSelectedIndex, actionButton, disabled, tooltip, }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClick = (index) => {
        actionButton(index);
    };
    const handleMenuItemClick = (index) => {
        setSelectedIndex(index);
        setOpen(false);
        actionButton(index);
    };
    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };
    const handleClose = (event) => {
        // @ts-ignore
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    return (jsxs(Fragment, { children: [jsx(Tooltip, Object.assign({ title: tooltip || '', arrow: true }, { children: jsxs(ButtonGroup$1, Object.assign({ disabled: disabled, variant: "contained", ref: anchorRef, "aria-label": "split button" }, { children: [jsx(Button, Object.assign({ disabled: disabled, onClick: () => handleClick(selectedIndex), startIcon: options[selectedIndex].icon }, { children: options[selectedIndex].buttonText })), jsx(Button, Object.assign({ disabled: disabled, size: "small", "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-label": "select merge strategy", "aria-haspopup": "menu", onClick: handleToggle }, { children: jsx(ArrowDropDownIcon, {}) }))] })) })), jsx(Popper, Object.assign({ sx: {
                    zIndex: 1,
                }, open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true }, { children: ({ TransitionProps, placement }) => (jsx(Grow, Object.assign({ style: {
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    } }, TransitionProps, { children: jsx(Paper, { children: jsx(ClickAwayListener, Object.assign({ onClickAway: handleClose }, { children: jsx(MenuList, Object.assign({ id: "split-button-menu" }, { children: options.map((option, index) => (jsx(Tooltip, Object.assign({ title: option.tooltip || '', arrow: true }, { children: jsx("div", { children: jsx(MenuItem, Object.assign({ disabled: option.disabled, selected: index === selectedIndex, onClick: () => handleMenuItemClick(index) }, { children: option.optionText }), index) }) })))) })) })) }) }))) }))] }));
};

export { ButtonGroup };
